import { render, staticRenderFns } from "./NameList.vue?vue&type=template&id=2c171e35&scoped=true&"
import script from "./NameList.vue?vue&type=script&lang=js&"
export * from "./NameList.vue?vue&type=script&lang=js&"
import style0 from "./NameList.vue?vue&type=style&index=0&id=2c171e35&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c171e35",
  null
  
)

export default component.exports